import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { map, filter, withLatestFrom } from 'rxjs/operators';
import { GET_SUBDOMAIN_SUCCESS } from '../../subdomains/actions';
import { GetSubdomainSuccess } from '../../subdomains/action-creators';
import AppState from '../../state';

export const identifyArtistSubscriptionEpic = (action$: Observable<GetSubdomainSuccess>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType(GET_SUBDOMAIN_SUCCESS),
    withLatestFrom(state$),
    filter(([_, state]) => !!state.artist.active?.id),
    map(([action, state]) => {
      if (window.analytics) {
        window.analytics.group(state.artist.active?.id as string , {
          subdomain: action.subdomain.subdomain
        });
      }
    }),
    filter(() => false)
  )